import {Inject, Injectable, Optional} from '@angular/core';

import {LIBRARY_CONFIG, LibraryConfig} from './config';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private readonly _config: LibraryConfig;

  // Inyecta la configuracion. @Optional() es util si quieres proveer valores por defecto.
  constructor(@Optional() @Inject(LIBRARY_CONFIG) config?: LibraryConfig) {
    // Provee valores por defecto si no se pasa configuracion
    this._config = config || {
      env: 'dev',
      apiUrl: 'https://api.defecto.com',
      bucketUrl: 'https://storage.googleapis.com/mitorneo-local',
      enableDebugMode: false,
    };

    // if (this._config.enableDebugMode) {
    //   console.log('libreria Tournaments en modo debug', this._config);
    // }
  }

  public get config(): LibraryConfig {
    return this._config;
  }
}
